export interface AttributionLine {
  // «Contours:» - подпись, если у источника она есть; значение идёт ниже с отступом.
  label: string | null;
  html: string;
}

// MapLibre склеивает attribution источников через « | » в одну строку.
// Для окна «Данные карты» режем её обратно: один источник - одна строка;
// «Подпись: значение» дополнительно делится на подпись и значение под ней.
export const splitAttribution = (html: string): AttributionLine[] =>
  html
    .split(/\s*\|\s*/)
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      // Подпись - обычный текст до двоеточия, без тегов (ссылка © OpenStreetMap
      // двоеточия до тега не содержит и остаётся целой строкой).
      const m = part.match(/^([^<>:]+:)\s*(.+)$/s);
      return m ? { label: m[1].trim(), html: m[2].trim() } : { label: null, html: part };
    });
